import React, { useState } from 'react'
import { Container, PaginationList } from './Styled'
import { List } from 'antd'
import { usePrevious } from '../../../helpers/hooks'
import _ from 'lodash'

type MenuListProps<T> = {
    header?: React.ReactNode
    dataSource: T[]
    renderItem?: (item: T, index: number) => React.ReactNode
    onSelect: (item?: T | null) => void
    defaultSelectedIndex?: number | undefined | null
    size?: 'small' | 'medium' | 'large'
    onLoadMore?: (page: Number) => void
    pageCount?: number
    pageSize?: number
}

const MenuList = <T extends any>(props: MenuListProps<T>) => {
    const [currentPage, setcurrentPage] = useState(1);
    const prevDataSource: T[] | undefined = usePrevious<T[]>(props.dataSource)
    if (
        props.defaultSelectedIndex &&
        !props.dataSource.some(item => item.id === props.defaultSelectedIndex)
    ) {
        props.onSelect(null)
    } else if (
        props.dataSource.length > (prevDataSource ? prevDataSource.length : 0)
    ) {
        const diffObjects = _.difference(
            props.dataSource,
            prevDataSource ? prevDataSource : []
        )
        if (diffObjects.length === 1) props.onSelect(diffObjects[0])
    } else if (
        props.dataSource.length < (prevDataSource ? prevDataSource.length : 0)
    ) {
        props.onSelect(null)
    } 

    const loadMore = (page: number) => {
        if(props.onLoadMore){
            props.onLoadMore(page - 1)
            setcurrentPage(page)
        }
    }

    return (
        <Container isPaginate={props.onLoadMore !== undefined} size={props.size}>
                <List
                    header={props.header}
                    bordered
                    dataSource={props.dataSource}
                    // @ts-ignore
                    renderItem={props.renderItem}
                    footer={props.onLoadMore ? <PaginationList current={currentPage} onChange={(page: number) => loadMore(page)} showSizeChanger={false} pageSize={props.pageSize ? props.pageSize : 50 } total={props.pageCount ? props.pageCount! : 0} /> : null}
                />
        </Container>
    )
}

export default MenuList
export { default as Item } from './item'
